import $ from 'jquery';

$(function () {
  const term = $('.js-accordionTerm');
  const contents = $('.js-accordionContents');
  term.on('click', function () {
    if (!window.matchMedia('(min-width: 1200px)').matches) {
      $(this).toggleClass('is-open').next('.js-accordionContents').slideToggle(300);
    }
  });

  $(window).on('resize', function () {
    let flag = '';
    if (window.matchMedia('(min-width: 1200px)').matches) {
      contents.show();
      if (flag !== 'pc') {
        const transitionDuration = parseFloat(contents.css('transition-duration')) * 1000;
        contents.css('transition', 'none');
        setTimeout(function () {
          contents.css('transition', '');
        }, transitionDuration);
      }
      flag = 'pc';
    } else {
      contents.hide();
      if (flag !== 'sp') {
        const transitionDuration = parseFloat(contents.css('transition-duration')) * 1000;
        contents.css('transition', 'none');
        setTimeout(function () {
          contents.css('transition', '');
        }, transitionDuration);
      }
      flag = 'sp';
    }
  });
});
